module.exports = __webpack_public_path__ + "img/pageinteriors_03auditoria-en-seguros-02.7ec3d61e.jpg";